import { render, staticRenderFns } from "./relSugumDialog.vue?vue&type=template&id=0047dd2a"
import script from "./relSugumDialog.vue?vue&type=script&lang=js"
export * from "./relSugumDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports